import Vue from 'vue'
import { getLoginUser } from '@/api/user'
import moment from 'moment'

export default Vue.extend({
  name: 'PurchaseHistory',
  data() {
    return {
      contract: [],
      headers: [
        { text: '購入日', value: 'contract_at', align: 'left' },
        { text: '金額', value: 'price', align: 'left' },
        {
          text: 'お支払い方法',
          value: 'payment_method',
          align: 'left'
        },
        {
          text: '内容',
          value: 'content_title',
          align: 'left'
        },
        { text: '有効期間', value: 'contract_at', align: 'center' }
      ],
      windowWidth: window.innerWidth
    }
  },
  async mounted() {
    this.fetchUser()
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
  },
  computed: {
    isMobile() {
      return this.windowWidth <= 1263
    }
  },
  methods: {
    async fetchUser() {
      await getLoginUser().then(res => {
        this.contract = []
        res.data.contracts.forEach(contract => {
          if (contract.payment_method) {
            switch (contract.payment_method) {
              case 'paypal':
                contract.payment_method = 'PayPal'
                break
              case 'stripe':
                contract.payment_method = 'Stripe'
                break
              default:
                break
            }
          }
          this.contract.push(contract)
        })
      })
    },
    formatContractAt(para) {
      return moment(para).format('YYYY/MM/DD')
    }
  }
})
